import { api } from "@/lib/api";

const sid = () => {
  let s = sessionStorage.getItem("smartsn_sid");
  if (!s) {
    s = crypto.randomUUID();
    sessionStorage.setItem("smartsn_sid", s);
  }
  return s;
};

export const trackVisit = () => {
  if (sessionStorage.getItem("smartsn_v")) return;
  sessionStorage.setItem("smartsn_v", "1");
  const src = new URLSearchParams(window.location.search).get("utm_source") || "";
  api.post("/track", { type: "visit", src }).catch(() => {});
};

export const initSectionTracking = () => {
  const seen = new Set(JSON.parse(sessionStorage.getItem("smartsn_s") || "[]"));
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && e.target.id && !seen.has(e.target.id)) {
          seen.add(e.target.id);
          sessionStorage.setItem("smartsn_s", JSON.stringify([...seen]));
          api.post("/track", { type: "section", section: e.target.id, session: sid() }).catch(() => {});
        }
      });
    },
    { threshold: 0.3 }
  );
  document.querySelectorAll("section[id]").forEach((s) => obs.observe(s));
  return () => obs.disconnect();
};
